"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.RADIO_BUTTON_SHAPES = void 0;
var RADIO_BUTTON_SHAPES = Object.freeze({
  squared: 'squared',
  pill: 'pill'
});
exports.RADIO_BUTTON_SHAPES = RADIO_BUTTON_SHAPES;